import React from 'react';
import { useTranslation } from 'react-i18next';
import { GraduationCap, Stethoscope, Briefcase, CloudRain } from 'lucide-react';
import './CategoryCards.css';

const CategoryCards = () => {
  const { t } = useTranslation();
  const categories = [
    { icon: GraduationCap, title: t('category_card_education_support_title') },
    { icon: Stethoscope, title: t('category_card_healthcare_initiatives_title') },
    { icon: Briefcase, title: t('category_card_livelihood_programs_title') },
    { icon: CloudRain, title: t('category_card_access_water_title') }
  ];

  return (
    <section className="category-cards section-padding">
      <div className="container">
        <div className="cards-row">
          {categories.map((category, index) => {
            const Icon = category.icon;
            return (
              <div key={category.title} className={`category-card fade-up stagger-${index + 1}`}>
                <Icon size={28} className="card-icon" />
                <h3 className="card-title">{category.title}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryCards;
